export default __webpack_public_path__ + "static/media/fuji-sakura.795ed0a0.gif";